import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SuccessPopUpComponent } from '../success-pop-up/success-pop-up.component';
import { creditCard } from 'src/app/models/creditCardInfoModel';
import { PaymentService } from 'src/app/_services/payment.service';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-confir-pop-up',
  templateUrl: './confir-pop-up.component.html',
  styleUrls: ['./confir-pop-up.component.css']
})

export class ConfirPopUpComponent implements OnInit {
  transactionPaymentId: any;
  isLoading: boolean = false;
  token:string;
  constructor(
    public paymentService: PaymentService,
    public dialogRef: MatDialogRef<ConfirPopUpComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public alertService: AlertService,
    public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute,
  ) { }

  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  transId: number;
  ngOnInit(): void {
    this.route.queryParams.subscribe((result) => {
      this.token=result.at;
    })
  }
  onNoClick(): void {
    setTimeout(() => {
      this.dialogRef.close();
    }, 1500);
  }

  maskCreditCardNumberForPayload(cardNumber: any) {
    if (cardNumber.length === 16) {
      return cardNumber.substr(0, 4) + '********' + cardNumber.substr(12, 4);
    } else {
      return cardNumber;
    }
  }

  maskCSC(csc: any) {
    if (csc.length === 3) {
      return 'xxx';
    } else {
      return csc;
    }
  }

  ccNumber = this.data.ccNumber;
  csc = this.data.csc;

  onClick() {
    console.log('onClick API call initiated');
    this.isLoading = true;
    //  this.route.queryParams.subscribe((result) => {
      console.log('queryParams API call initiated');
      console.log(this.token);
      this.data.ccNumber = this.maskCreditCardNumberForPayload(this.data.ccNumber);
      this.data.csc = this.maskCSC(this.data.csc);
      this.paymentService.getNewToken(this.token).subscribe
      ((tknResp) => {
        this.paymentService.addPaymentTransaction(this.data,tknResp.token).subscribe
        ((response) => {
          console.log(response);
          this.transactionPaymentId = response.transactionPaymentId;
          if(response.errormesg)
          {
            this.alertService.error(response.errormesg, this.options);
            return;
          }
          this.paymentService.confirmPayment(tknResp.token, this.transactionPaymentId, this.ccNumber, this.csc)
            .subscribe((res) => {
              console.log(res);
              var payRes=res?.data?.split("|");
              if(payRes[0]=="0")
              {
                this.isLoading = false;
                this.alertService.success('Success!! Your payment has been confirm successfully.', this.options);
                this.router.navigate(['/success']);
              }
              else
              {
                this.alertService.error(res?.data, this.options);
              }
            }, (err) => {
              console.log(err);
              this.isLoading = false;
              this.alertService.error(err.data, this.options);
              //this.alertService.error(err.error.error.message, this.options);
            })
        }, (errr) => {
          console.log(errr);
          this.isLoading = false;
          this.alertService.error(errr.errormesg, this.options);
          // this.alertService.error(errr.error.errors.messages, this.options);
        })

      }, (tknErr) => {
        console.log(tknErr);
        this.isLoading = false;
        this.alertService.error(tknErr.error.error, this.options);
        // this.alertService.error(errr.error.errors.messages, this.options);
      })
      
    // })
  }
}
